export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Uuid: { input: any; output: any; }
};

export type AuthPayloadType = {
  __typename?: 'AuthPayloadType';
  /** Access token expiration timestamp. Null for non-expiring MVP tokens. */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** Access token for use in the X-AUTH-TOKEN header. */
  token: Scalars['String']['output'];
  /** Authenticated user profile. */
  user: UserProxyType;
};

export enum CallRequestDisabledReason {
  ActiveRequest = 'ACTIVE_REQUEST',
  InvalidReservationStatus = 'INVALID_RESERVATION_STATUS',
  None = 'NONE',
  NotAuthorized = 'NOT_AUTHORIZED',
  NoPremium = 'NO_PREMIUM',
  NoSchedule = 'NO_SCHEDULE'
}

export type CallRequestStatusType = {
  __typename?: 'CallRequestStatusType';
  /** Date and time when call requests will become available again. Null if already enabled. */
  availableAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reason why the call request is disabled. NONE if currently enabled. */
  disabledReason: CallRequestDisabledReason;
  /** True if the user can currently submit a call request. */
  enabled: Scalars['Boolean']['output'];
  /** Moderator working schedule. Null if no schedule is configured. */
  moderatorSchedule?: Maybe<ModeratorScheduleType>;
  /** True if the call request button should be shown to the user. */
  visible: Scalars['Boolean']['output'];
};

/** Input for cancelling an active premium subscription. */
export type CancelSubscriptionInput = {
  /** ID of the payment order to cancel. */
  orderId: Scalars['Int']['input'];
  /** Subscription plan to cancel. */
  planId: GraphQlSubscriptionPlan;
};

export type CatalogType = {
  __typename?: 'CatalogType';
  /** True when another catalog page can be requested. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Opaque JSON pagination token. Pass it back as searchAfter to request the next page. */
  nextSearchAfter?: Maybe<Scalars['String']['output']>;
  /** Catalog venue summaries sourced from the existing monolith catalog. */
  restaurants?: Maybe<Array<RestaurantType>>;
};

export type CountryPricesType = {
  __typename?: 'CountryPricesType';
  /** ISO 3166-1 alpha-2 code of the country these prices apply to. */
  countryCode: Scalars['String']['output'];
  /** List of available subscription plans with their prices. */
  plans?: Maybe<Array<PlanPricesType>>;
};

export type CountryProxyType = {
  __typename?: 'CountryProxyType';
  /** Country database ID. */
  id: Scalars['Int']['output'];
  /** ISO 3166-1 alpha-2 country code (e.g. US, UA). */
  isoCode: Scalars['String']['output'];
  /** Display name of the country. */
  name: Scalars['String']['output'];
  /** URL-friendly identifier used in routing. */
  slug: Scalars['String']['output'];
};

export type CurrencyPriceType = {
  __typename?: 'CurrencyPriceType';
  /** Price per billing unit before discounts (in the given currency). */
  amount: Scalars['Float']['output'];
  /** ISO 4217 currency code (e.g. USD, EUR). */
  currencyCode: Scalars['String']['output'];
  /** Final price after applying any promo code discount. */
  finalAmount: Scalars['Float']['output'];
  /** Discount amount applied by the promo code. Null if no promo code was used. */
  promocodeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyProxyType = {
  __typename?: 'CurrencyProxyType';
  /** Number of decimal places used for this currency. */
  decimalSeparator: Scalars['Int']['output'];
  /** Currency database ID. */
  id: Scalars['Int']['output'];
  /** True if amounts in this currency are always whole numbers (no decimals). */
  isIntegerCurrency: Scalars['Boolean']['output'];
  /** Currency full name (e.g. US Dollar). */
  name: Scalars['String']['output'];
  /** Currency symbol (e.g. $, €). */
  sign: Scalars['String']['output'];
};

export type CustomPlaceType = {
  __typename?: 'CustomPlaceType';
  /** Country where the custom place is located. */
  country: CountryProxyType;
  /** Physical address or location of the custom place. */
  location: Scalars['String']['output'];
  /** Name of the custom place. */
  name: Scalars['String']['output'];
};

export type CustomReservationInput = {
  /** Must be true — the user agrees to the terms of service. */
  agreeTerms: Scalars['Boolean']['input'];
  /** Optional guest comment for the reservation (max 1000 characters). */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code (e.g. US, ES, UA). */
  countryCode: Scalars['String']['input'];
  /** Flexibility window around the reservation time. */
  flexibility: ReservationFlexibility;
  /** Number of guests (1–50). */
  guestsCount: Scalars['Int']['input'];
  /** Physical address or location of the place. */
  location: Scalars['String']['input'];
  /** Date and time of the reservation. Must be aligned to a 15-minute interval. */
  reservationAt: Scalars['DateTime']['input'];
  /** Name of the restaurant or place for the custom reservation. */
  restaurantName: Scalars['String']['input'];
  /** Contact details of the guest making the reservation. */
  userInfo: UserInfoInput;
};

export enum EmailValidationStatus {
  Exists = 'EXISTS',
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type FavoriteRestaurantType = {
  __typename?: 'FavoriteRestaurantType';
  /** Date and time when the restaurant was added to favorites. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The favorited restaurant. */
  restaurant: RestaurantType;
};

export enum FavoriteSortField {
  DateAdded = 'DATE_ADDED',
  Name = 'NAME'
}

export type FavoritesPaginatedType = {
  __typename?: 'FavoritesPaginatedType';
  /** Current page number. */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** Paginated list of favorite restaurants. */
  items?: Maybe<Array<FavoriteRestaurantType>>;
  /** Number of items per page. */
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages. */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of items across all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GeoType = {
  __typename?: 'GeoType';
  /** City name detected from IP. Null if not detected. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name detected from IP. Null if not detected. */
  country?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 country code detected from IP. Null if not detected. */
  countryIso2Code?: Maybe<Scalars['String']['output']>;
  /** Client IP address used for geo detection. */
  ip?: Maybe<Scalars['String']['output']>;
  /** Timezone identifier detected from IP (e.g. Europe/Kyiv). Null if not detected. */
  timeZone?: Maybe<Scalars['String']['output']>;
};

export enum GraphQlSubscriptionPlan {
  PremiumMonthly = 'PREMIUM_MONTHLY',
  PremiumYearly = 'PREMIUM_YEARLY'
}

export enum GraphQlSubscriptionStatus {
  Cancel = 'CANCEL',
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export type ModeratorScheduleType = {
  __typename?: 'ModeratorScheduleType';
  /** True if the moderator is currently within working hours. */
  isWorking: Scalars['Boolean']['output'];
  /** Timezone identifier for the moderator's working hours. */
  timezone: Scalars['String']['output'];
  /** Start of the moderator's working hours (HH:MM). */
  workFrom: Scalars['String']['output'];
  /** End of the moderator's working hours (HH:MM). */
  workTo: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds a restaurant to the current user's favorites. Requires authentication. */
  addFavorite: Scalars['Boolean']['output'];
  /** Cancels an existing reservation by UUID. Cancellation rules depend on reservation status and user premium tier. */
  cancelReservation: Scalars['Boolean']['output'];
  /** Cancels the user's active premium subscription. */
  cancelSubscription: Scalars['Boolean']['output'];
  /** Submits a call request for a reservation. Returns the updated call request availability status. Requires authentication. */
  createCallRequest: CallRequestStatusType;
  /** Creates a custom reservation at a user-specified place (not from the restaurant catalog). Requires authentication and an active premium subscription. */
  createCustomReservation: ReservationType;
  /** Creates a new table reservation at a restaurant. */
  createReservation: ReservationType;
  /** Submits how the user found the service for a specific reservation. Accepts SKIPPED when the user dismisses the form. Non-skip answers are also stored on the user profile to prevent showing the question again. */
  createReservationSource: Scalars['Boolean']['output'];
  /** Submits a request to add a restaurant to ME-Booking. Public, no authentication required. */
  createRestaurantAddRequest: Scalars['Boolean']['output'];
  /** Submits a merchant opt-out request (removal from ME-Booking). Public, no authentication required. */
  createRestaurantDeleteRequest: Scalars['Boolean']['output'];
  /** Creates a new review for a restaurant. Requires authentication. */
  createReview: ReviewType;
  /** Submits a new support request. Can be sent by both authenticated users and guests. */
  createSupportRequest: Scalars['Boolean']['output'];
  /** Deletes an existing restaurant review by UUID. Requires authentication and ownership. */
  deleteReview: Scalars['Boolean']['output'];
  /** Removes a specific photo from a restaurant review. Requires authentication and ownership. */
  deleteReviewPhoto: Scalars['Boolean']['output'];
  /** Permanently deletes the current user's account. Requires authentication. */
  deleteUser: Scalars['Boolean']['output'];
  /** Authenticates a user and returns an X-AUTH-TOKEN payload. */
  login: AuthPayloadType;
  /** Initiates the premium subscription payment flow and returns a redirect URL to the payment provider. Requires authentication. */
  premiumPaymentMiddleware: Scalars['String']['output'];
  /** Registers a user and returns an X-AUTH-TOKEN payload. */
  register: AuthPayloadType;
  /** Removes a restaurant from the current user's favorites. Requires authentication. */
  removeFavorite: Scalars['Boolean']['output'];
  /** Authenticates a social user and returns an X-AUTH-TOKEN payload. */
  socialLogin: AuthPayloadType;
  /** Updates an existing reservation by UUID. Guest email cannot be changed after booking. */
  updateReservation: ReservationType;
  /** Updates an existing restaurant review by UUID. Requires authentication and ownership. */
  updateReview: ReviewType;
  /** Updates the current user's profile information. Requires authentication. */
  updateUser: UserProxyType;
};


export type MutationAddFavoriteArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationCancelReservationArgs = {
  uuid: Scalars['Uuid']['input'];
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCreateCallRequestArgs = {
  reservationUuid: Scalars['Uuid']['input'];
};


export type MutationCreateCustomReservationArgs = {
  input: CustomReservationInput;
};


export type MutationCreateReservationArgs = {
  input: ReservationInput;
};


export type MutationCreateReservationSourceArgs = {
  reservationUuid: Scalars['Uuid']['input'];
  source: ReservationDiscoverySource;
};


export type MutationCreateRestaurantAddRequestArgs = {
  input: RestaurantAddRequestInput;
};


export type MutationCreateRestaurantDeleteRequestArgs = {
  input: RestaurantDeleteRequestInput;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
  restaurantId: Scalars['Int']['input'];
};


export type MutationCreateSupportRequestArgs = {
  input: SupportRequestInput;
};


export type MutationDeleteReviewArgs = {
  uuid: Scalars['Uuid']['input'];
};


export type MutationDeleteReviewPhotoArgs = {
  photoId: Scalars['Int']['input'];
  reviewUuid: Scalars['Uuid']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPremiumPaymentMiddlewareArgs = {
  input: PremiumMiddlewareInput;
};


export type MutationRegisterArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRemoveFavoriteArgs = {
  restaurantId: Scalars['Int']['input'];
};


export type MutationSocialLoginArgs = {
  token: Scalars['String']['input'];
  type: SocialLoginType;
};


export type MutationUpdateReservationArgs = {
  input: ReservationUpdateInput;
  uuid: Scalars['Uuid']['input'];
};


export type MutationUpdateReviewArgs = {
  input: ReviewInput;
  uuid: Scalars['Uuid']['input'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PhotoType = {
  __typename?: 'PhotoType';
  /** Photo ID from me-pos. */
  id: Scalars['Int']['output'];
  /** Public URL of the photo. */
  url: Scalars['String']['output'];
};

export type PlanPricesType = {
  __typename?: 'PlanPricesType';
  /** List of prices in different currencies for this plan. */
  currencies?: Maybe<Array<CurrencyPriceType>>;
  /** Subscription plan identifier. */
  planId: GraphQlSubscriptionPlan;
};

/** Input for initiating the premium subscription payment flow. */
export type PremiumMiddlewareInput = {
  /** Optional promo code to apply a discount. */
  coupon?: InputMaybe<Scalars['String']['input']>;
  /** ISO 4217 currency code for the payment (default: 'usd'). */
  currencyCode?: Scalars['String']['input'];
  /** Subscription plan to purchase. */
  planId: GraphQlSubscriptionPlan;
  /** URL to redirect to if the payment is cancelled. */
  targetCancelLink?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to after a successful payment. */
  targetSuccessLink?: InputMaybe<Scalars['String']['input']>;
};

export type PremiumPaymentOrderProxyType = {
  __typename?: 'PremiumPaymentOrderProxyType';
  /** Original order amount in the base currency (USD). */
  amount: Scalars['Float']['output'];
  /** Order creation timestamp (Y-m-d H:i:s). */
  createdAt: Scalars['String']['output'];
  /** Currency used for this order. */
  currency: CurrencyProxyType;
  /** Amount in the user's local currency. Null if not set or zero (typically when payment is in the base currency). */
  currencyAmount?: Maybe<Scalars['Float']['output']>;
  /** Email address of the customer who placed the order. */
  customerEmail?: Maybe<Scalars['String']['output']>;
  /** Final charged amount after applying any discounts. */
  finalAmount: Scalars['Float']['output'];
  /** Final charged amount in the smallest currency unit (cents). */
  finalAmountInCent: Scalars['Float']['output'];
  /** The first recorded status of this order. Null for legacy orders without status history. */
  firstStatus?: Maybe<GraphQlSubscriptionStatus>;
  /** Order database ID. */
  id: Scalars['Int']['output'];
  /** True if the order was cancelled. */
  isCancelStatus: Scalars['Boolean']['output'];
  /** True if the first recorded status was FAIL. */
  isFailFirstStatus: Scalars['Boolean']['output'];
  /** True if the payment failed. */
  isFailStatus: Scalars['Boolean']['output'];
  /** True if the plan is billed monthly. */
  isMonthly: Scalars['Boolean']['output'];
  /** True if the order status is NEW (awaiting payment). */
  isNewStatus: Scalars['Boolean']['output'];
  /** True if the subscription is active but scheduled to cancel at the end of the billing period. */
  isSchedulingToCancellation: Scalars['Boolean']['output'];
  /** True if the first recorded status was SUCCESS. */
  isSuccessFirstStatus: Scalars['Boolean']['output'];
  /** True if the payment was successful. */
  isSuccessStatus: Scalars['Boolean']['output'];
  /** True if this is a test payment order. */
  isTest: Scalars['Boolean']['output'];
  /** True if the plan is billed yearly. */
  isYearly: Scalars['Boolean']['output'];
  /** Human-readable order identifier. */
  orderName: Scalars['String']['output'];
  /** Absolute URL to download the PDF invoice for this order. */
  pdfInvoiceUrl: Scalars['String']['output'];
  /** Subscription plan associated with this order. */
  planId: GraphQlSubscriptionPlan;
  /** ID of the parent order, if this is a renewal or child order. Null for initial orders. */
  prentOrderId?: Maybe<Scalars['Int']['output']>;
  /** Discount amount applied by a promo code. Null if no promo code was used. */
  promocodeDiscount?: Maybe<Scalars['Float']['output']>;
  /** Current status of the payment order. */
  status: GraphQlSubscriptionStatus;
  /** URL to the Stripe-hosted invoice. Null if not available. */
  stripeInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** External subscription ID from the payment provider. */
  subscriptionId?: Maybe<Scalars['String']['output']>;
};


export type PremiumPaymentOrderProxyTypeFinalAmountArgs = {
  returnInDollars?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PremiumPaymentOrderProxyTypeFinalAmountInCentArgs = {
  returnInDollars?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PremiumPaymentOrderProxyTypePromocodeDiscountArgs = {
  returnInDollars?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Catalog browse query backed by the existing Twig/AJAX catalog source. Catalog data is not real-time availability truth. */
  catalog: CatalogType;
  /** Returns a list of all available countries. */
  countries?: Maybe<Array<CountryProxyType>>;
  /** Returns subscription plan prices for the current country. Optionally applies a promo code coupon. */
  countryPrices: CountryPricesType;
  /** Detects the user's country, city, and timezone based on their IP address. */
  getGeoByIp: GeoType;
  /** Returns a single reservation by UUID. Returns null if not found. */
  reservation?: Maybe<ReservationType>;
  /** Returns a single restaurant review by UUID. Returns null if not found. */
  review?: Maybe<ReviewType>;
  /** Returns a list of available subject categories for support requests. */
  supportRequestSubjects?: Maybe<Array<SupportRequestSubjectProxyType>>;
  /** Development test query. Returns 'Hello {name}!'. */
  test: Scalars['String']['output'];
  /** Returns the currently authenticated user's profile. */
  user: UserProxyType;
  /** Checks whether an email is valid and not already registered. Returns VALID, INVALID, or EXISTS. */
  validateEmail: EmailValidationStatus;
  /** Runs input validation on reservation data without creating a reservation. Returns true if valid; returns validation errors otherwise. */
  validateReservation: Scalars['Boolean']['output'];
  /** Venue detail query by stable restaurantId. Returns null when the catalog venue is unavailable. */
  venue?: Maybe<RestaurantType>;
};


export type QueryCatalogArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  countrySlug?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchAfter?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountryPricesArgs = {
  coupon?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReservationArgs = {
  uuid: Scalars['Uuid']['input'];
};


export type QueryReviewArgs = {
  uuid: Scalars['Uuid']['input'];
};


export type QueryTestArgs = {
  name: Scalars['String']['input'];
};


export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateReservationArgs = {
  input: ReservationInput;
};


export type QueryVenueArgs = {
  restaurantId: Scalars['Int']['input'];
};

export enum ReservationDiscoverySource {
  /** The user was referred by a friend or acquaintance. */
  Friend = 'FRIEND',
  /** The user found the service through Google search or Google Maps. */
  Google = 'GOOGLE',
  /** The user found the service through a channel not listed above. */
  Other = 'OTHER',
  /** The user is a returning customer who already knew about the service. */
  Returning = 'RETURNING',
  /** The user dismissed the form without answering. The question will be shown again on the next reservation. */
  Skipped = 'SKIPPED',
  /** The user stumbled upon the service while browsing online (e.g. saw an ad, came across it on social media). */
  Stumbled = 'STUMBLED'
}

export enum ReservationFlexibility {
  /** ± 1 Hour */
  Hour_1 = 'HOUR_1',
  /** ± 2 Hours */
  Hour_2 = 'HOUR_2',
  /** ± 3 Hours */
  Hour_3 = 'HOUR_3',
  /** Exact Time */
  None = 'NONE'
}

/** Input for creating a new table reservation. */
export type ReservationInput = {
  /** Must be true to accept the terms of service. */
  agreeTerms: Scalars['Boolean']['input'];
  /** Optional guest comment for the reservation. Max 1000 characters. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** If true, a new user account is created from the guest contact info. */
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flexibility window around the reservation time. */
  flexibility: ReservationFlexibility;
  /** Number of guests (1–50). */
  guestsCount: Scalars['Int']['input'];
  /** Desired reservation date and time. Minutes must be a multiple of 15. */
  reservationAt: Scalars['DateTime']['input'];
  /** ID of the restaurant to reserve at. */
  restaurantId: Scalars['Int']['input'];
  /** Google rwg_token for conversion tracking. Required when booking via Google Business Link on mobile (web clients use the cookie automatically). */
  rwgToken?: InputMaybe<Scalars['String']['input']>;
  /** Internal testing flag. When true, the reservation Telegram notification is routed to the test chat (web clients use the test_notifications cookie automatically). */
  testNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contact details of the guest making the reservation. */
  userInfo: UserInfoInput;
};

export type ReservationPaginatedType = {
  __typename?: 'ReservationPaginatedType';
  /** Current page number. */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** Paginated list of reservations. */
  items?: Maybe<Array<ReservationType>>;
  /** Number of items per page. */
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages. */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of items across all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ReservationSortField {
  CreatedAt = 'CREATED_AT',
  ReservationAt = 'RESERVATION_AT',
  RestaurantName = 'RESTAURANT_NAME',
  Status = 'STATUS'
}

export enum ReservationStatus {
  CancelledByUser = 'CANCELLED_BY_USER',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  NoConnection = 'NO_CONNECTION',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  WaitingForOpening = 'WAITING_FOR_OPENING'
}

export type ReservationType = {
  __typename?: 'ReservationType';
  /** Google Calendar event URL for this reservation. Null if the restaurant is unavailable. */
  calendarGoogleUrl?: Maybe<Scalars['String']['output']>;
  /** Absolute URL to download an ICS calendar file for this reservation. */
  calendarIcsUrl: Scalars['String']['output'];
  /** Optional guest comment for the reservation. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the reservation was created. Accepts an optional format argument (default: Y-m-d H:i:s). */
  createdAt: Scalars['String']['output'];
  /** Custom place details for non-catalog reservations. Null if the reservation was made at a catalog restaurant. */
  customPlace?: Maybe<CustomPlaceType>;
  /** Flexibility window around the reservation time. */
  flexibility: ReservationFlexibility;
  /** Number of guests for this reservation. */
  guestsCount: Scalars['Int']['output'];
  /** Reservation ID from me-pos. */
  id: Scalars['Int']['output'];
  /** True if this reservation was made with a premium subscription. */
  isPremium: Scalars['Boolean']['output'];
  /** Optional comment left by the moderator. */
  moderatorComment?: Maybe<Scalars['String']['output']>;
  /** Date and time of the reservation. Accepts an optional format argument (default: Y-m-d H:i:s). */
  reservationAt: Scalars['String']['output'];
  /** Restaurant where the reservation was made. Null if the reservation is at a custom place or if the restaurant no longer exists in the catalog. */
  restaurant?: Maybe<RestaurantType>;
  /** Current status of the reservation. */
  status: ReservationStatus;
  /** Timestamp of the last update to the reservation. Accepts an optional format argument (default: Y-m-d H:i:s). */
  updatedAt: Scalars['String']['output'];
  /** The user who made the reservation. Null for guest. */
  user?: Maybe<UserProxyType>;
  /** Globally unique reservation identifier (UUID). */
  uuid: Scalars['Uuid']['output'];
};


export type ReservationTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ReservationTypeReservationAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ReservationTypeUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing reservation. */
export type ReservationUpdateInput = {
  /** Updated contact details for the reservation. */
  userInfo: UserInfoInput;
};

/** Input for submitting a request to add a restaurant to ME-Booking. */
export type RestaurantAddRequestInput = {
  /** Full address of the venue. */
  address: Scalars['String']['input'];
  /** City of the venue. */
  city: Scalars['String']['input'];
  /** Optional notes / message. Max 1000 characters. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Must be true: confirms the sender represents the venue and agrees to be contacted. */
  confirmRepresentative: Scalars['Boolean']['input'];
  /** Contact email. */
  contactEmail: Scalars['String']['input'];
  /** Contact person name. */
  contactName: Scalars['String']['input'];
  /** Contact phone in international format (e.g. +380501234567). */
  contactPhone: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code of the venue. */
  countryIsoCode: Scalars['String']['input'];
  /** Optional Google Maps / Google Business Profile link. */
  googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
  /** Role / position of the contact person (e.g. Owner, Manager, Marketing, Other). */
  role: Scalars['String']['input'];
  /** Restaurant / venue name. */
  venueName: Scalars['String']['input'];
  /** Optional venue website. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantCuisineType = {
  __typename?: 'RestaurantCuisineType';
  /** Cuisine type ID. */
  id: Scalars['Int']['output'];
  /** Cuisine type name (e.g. Italian, Japanese). */
  name: Scalars['String']['output'];
};

export enum RestaurantDeleteReason {
  IncorrectInfo = 'INCORRECT_INFO',
  NotAssociated = 'NOT_ASSOCIATED',
  NotListed = 'NOT_LISTED',
  NoBookings = 'NO_BOOKINGS',
  Other = 'OTHER'
}

/** Input for submitting a merchant opt-out request (removal from ME-Booking). */
export type RestaurantDeleteRequestInput = {
  /** Full address of the venue. */
  address: Scalars['String']['input'];
  /** City of the venue. */
  city: Scalars['String']['input'];
  /** Optional additional comments. Max 1000 characters. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Must be true: confirms the sender represents the venue and requests removal. */
  confirmRepresentative: Scalars['Boolean']['input'];
  /** Contact email. */
  contactEmail: Scalars['String']['input'];
  /** Contact person name. */
  contactName: Scalars['String']['input'];
  /** Contact phone in international format (e.g. +380501234567). */
  contactPhone: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code of the venue. */
  countryIsoCode: Scalars['String']['input'];
  /** Optional Google Maps / Google Business Profile link. */
  googleMapsUrl?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the opt-out request. */
  reason: RestaurantDeleteReason;
  /** Role / position of the contact person (e.g. Owner, Manager, Marketing, Other). */
  role: Scalars['String']['input'];
  /** Restaurant / venue name. */
  venueName: Scalars['String']['input'];
  /** Optional venue website. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantType = {
  __typename?: 'RestaurantType';
  /** Short address of the restaurant. */
  address: Scalars['String']['output'];
  /** Reservable time intervals split per calendar day. Overnight shifts are cut at midnight (the morning tail goes to the next day) and the last hour before closing is excluded; closeTimeSeconds/closeTime is the last reservable moment, not the closing time. */
  availableForReservation: Array<WorkScheduleType>;
  /** List of cuisine types offered by the restaurant. */
  cuisines: Array<RestaurantCuisineType>;
  /** Full formatted address including city and country. */
  fullAddress: Scalars['String']['output'];
  /** Restaurant ID from Elasticsearch. */
  id: Scalars['Int']['output'];
  /** True if the restaurant is currently open. */
  isOpenNow: Scalars['Boolean']['output'];
  /** Absolute URL to the restaurant's detail page. */
  link: Scalars['String']['output'];
  /** URL to the restaurant's logo image. */
  logo: Scalars['String']['output'];
  /** List of menu photo URLs. */
  menuPhotos: Array<Scalars['String']['output']>;
  /** External URL to the restaurant's menu. Null if not available. */
  menuUrl?: Maybe<Scalars['String']['output']>;
  /** Restaurant display name. */
  name: Scalars['String']['output'];
  /** Next opening time. Today's time in 12-hour format (e.g. '9:00 AM'), or with a day prefix if opening on a future day (e.g. 'Monday, 9:00 AM'). Null if not determinable. */
  openAt?: Maybe<Scalars['String']['output']>;
  /** Closing time for today in 12-hour format (e.g. '10:00 PM'). Null if the restaurant is currently closed or the schedule is unknown. */
  openUntil?: Maybe<Scalars['String']['output']>;
  /** Formatted price range. Either a currency+price string (e.g. '€50+') or a dollar-sign level (e.g. '$$$'). Empty string if unknown. */
  priceRange: Scalars['String']['output'];
  /** Average customer rating. Null if no reviews yet. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Total number of customer reviews. */
  reviewCount: Scalars['Int']['output'];
  /** URL-friendly restaurant identifier. */
  slug: Scalars['String']['output'];
  /** List of restaurant type categories (e.g. Fine Dining, Casual). */
  types: Array<RestaurantTypeType>;
  /** UTC offset of the restaurant's timezone in minutes. */
  utcOffsetMinutes: Scalars['Int']['output'];
  /** Raw weekly work schedule, one entry per shift. openTimeSeconds/closeTimeSeconds are seconds since local midnight; an overnight shift has closeTimeSeconds <= openTimeSeconds (closes the next day). */
  workSchedules: Array<WorkScheduleType>;
  /** Weekly work schedule formatted per day. */
  workSchedulesFormated: Array<WorkScheduleFormatedType>;
};

export type RestaurantTypeType = {
  __typename?: 'RestaurantTypeType';
  /** Restaurant type ID. */
  id: Scalars['Int']['output'];
  /** Restaurant type name (e.g. Fine Dining, Cafe). */
  name: Scalars['String']['output'];
};

export enum ReviewBillPerPerson {
  /** \$1-10 */
  From_1 = 'FROM_1',
  /** \$10-50 */
  From_10 = 'FROM_10',
  /** \$50-100 */
  From_50 = 'FROM_50',
  /** \$100+ */
  From_100 = 'FROM_100'
}

/** Input for creating or updating a restaurant review. */
export type ReviewInput = {
  /** Atmosphere rating (1–5). Optional. */
  atmosphereRating?: InputMaybe<Scalars['Int']['input']>;
  /** Approximate bill per person category. Optional. */
  billPerPerson?: InputMaybe<ReviewBillPerPerson>;
  /** Review text. Max 1000 characters. Optional. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Food quality rating (1–5). Optional. */
  foodRating?: InputMaybe<Scalars['Int']['input']>;
  /** Overall restaurant rating (1–5). */
  overallRating: Scalars['Int']['input'];
  /** Photos to attach to the review. Max 8 files, 5 MB each (PNG/JPG). */
  photos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Service quality rating (1–5). Optional. */
  serviceRating?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewPaginatedType = {
  __typename?: 'ReviewPaginatedType';
  /** Current page number. */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** Paginated list of reviews. */
  items?: Maybe<Array<ReviewType>>;
  /** Number of items per page. */
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages. */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of items across all pages. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ReviewSortField {
  CreatedAt = 'CREATED_AT',
  Photos = 'PHOTOS',
  Rating = 'RATING',
  Relevance = 'RELEVANCE',
  RestaurantName = 'RESTAURANT_NAME'
}

export type ReviewType = {
  __typename?: 'ReviewType';
  /** Atmosphere rating (1–5). Null if not provided. */
  atmosphereRating?: Maybe<Scalars['Int']['output']>;
  /** Display name of the review author (first name + last initial). Null if the user is not found in the database or has no name set. */
  author?: Maybe<Scalars['String']['output']>;
  /** Approximate bill per person category. Null if not provided. */
  billPerPerson?: Maybe<ReviewBillPerPerson>;
  /** Review text written by the user. Null if no text was provided. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the review was created. Accepts an optional format argument (default: Y-m-d H:i:s). */
  createdAt: Scalars['String']['output'];
  /** Food quality rating (1–5). Null if not provided. */
  foodRating?: Maybe<Scalars['Int']['output']>;
  /** Overall restaurant rating (1–5). */
  overallRating: Scalars['Int']['output'];
  /** Photos attached to this review. */
  photos: Array<PhotoType>;
  /** Restaurant this review is about. Null if the restaurant no longer exists in the catalog. */
  restaurant?: Maybe<RestaurantType>;
  /** Service quality rating (1–5). Null if not provided. */
  serviceRating?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last update to the review. Accepts an optional format argument (default: Y-m-d H:i:s). */
  updatedAt: Scalars['String']['output'];
  /** Globally unique review identifier (UUID). */
  uuid: Scalars['Uuid']['output'];
};


export type ReviewTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ReviewTypeUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialLoginType {
  Apple = 'APPLE',
  Google = 'GOOGLE'
}

/** Input for submitting a support request. */
export type SupportRequestInput = {
  /** Detailed description of the issue. Max 1000 characters. */
  description: Scalars['String']['input'];
  /** Contact email. Required for guest users, optional for authenticated users. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Optional file attachment. Max 20 MB. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of the support subject category. */
  subjectId: Scalars['Int']['input'];
};

export type SupportRequestSubjectProxyType = {
  __typename?: 'SupportRequestSubjectProxyType';
  /** Subject database ID. */
  id: Scalars['Int']['output'];
  /** Display name of the support request subject category. */
  name: Scalars['String']['output'];
};

/** Input for updating the current user's profile. */
export type UpdateUserInput = {
  /** ID of the user's country. Optional. */
  countryId?: InputMaybe<Scalars['Int']['input']>;
  /** User's email address. */
  email: Scalars['String']['input'];
  /** User's first name. Max 50 characters. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's last name. Max 50 characters. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** New password. Min 8, max 4096 characters. Optional. */
  newPassword?: InputMaybe<Scalars['String']['input']>;
  /** User's phone number in international format. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Contact details of a reservation guest. */
export type UserInfoInput = {
  /** Guest's email address. */
  email: Scalars['String']['input'];
  /** Guest's first name. Max 50 characters. */
  firstName: Scalars['String']['input'];
  /** Guest's phone number in international format. */
  phone: Scalars['String']['input'];
};

export type UserPremiumProxyType = {
  __typename?: 'UserPremiumProxyType';
  /** The currently active payment order for this subscription. Null if no active order. */
  activeOrder?: Maybe<PremiumPaymentOrderProxyType>;
  /** URL to the Stripe customer portal for managing the subscription. Null if no active order or not supported. */
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  /** Date when the current premium subscription expires (Y-m-d H:i:s). */
  dueDate: Scalars['String']['output'];
  /** Premium subscription database ID. */
  id: Scalars['Int']['output'];
};


export type UserPremiumProxyTypeCustomerPortalUrlArgs = {
  backUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserProxyType = {
  __typename?: 'UserProxyType';
  /** User's selected country. Null if not set. */
  country?: Maybe<CountryProxyType>;
  /** User's email address. */
  email: Scalars['String']['output'];
  /** List of restaurant IDs marked as favorites. Optionally filtered by a provided subset of restaurant IDs. */
  favoriteRestaurantIds: Array<Scalars['Int']['output']>;
  /** Paginated list of the user's favorite restaurants with metadata. Supports sorting and search. */
  favorites: FavoritesPaginatedType;
  /** User's first name. Null if not set. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** True if the user has answered the discovery question with a real answer. False if never answered or skipped — the form should be shown again. */
  hasDiscoverySource: Scalars['Boolean']['output'];
  /** User database ID. */
  id: Scalars['Int']['output'];
  /** True if the user has completed registration. */
  isRegistered: Scalars['Boolean']['output'];
  /** User's last name. Null if not set. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** List of all past and current payment orders for this user. */
  paymentHistory?: Maybe<Array<PremiumPaymentOrderProxyType>>;
  /** User's phone number. Null if not set. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Active premium subscription data. Null if the user is not premium. */
  premium?: Maybe<UserPremiumProxyType>;
  /** Paginated list of the user's reservations. Supports search, sorting, and pagination. */
  reservations: ReservationPaginatedType;
  /** Paginated list of reviews written by this user. Supports search, sorting, and pagination. */
  reviews: ReviewPaginatedType;
};


export type UserProxyTypeFavoriteRestaurantIdsArgs = {
  restaurantIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type UserProxyTypeFavoritesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<FavoriteSortField>;
  sortOrder?: InputMaybe<Order>;
};


export type UserProxyTypeReservationsArgs = {
  order?: InputMaybe<Order>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<ReservationSortField>;
};


export type UserProxyTypeReviewsArgs = {
  order?: InputMaybe<Order>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<ReviewSortField>;
};

export type WorkScheduleFormatedType = {
  __typename?: 'WorkScheduleFormatedType';
  /** Localized day name. */
  dayName: Scalars['String']['output'];
  /** Day of week number, 0-based (0 = Monday, 6 = Sunday). */
  dayNumber: Scalars['Int']['output'];
  /** Working hour ranges for this day in 12-hour format (e.g. ['9:00 AM — 10:00 PM']). Contains the translated 'Closed' string when the restaurant is closed that day. */
  workingHour: Array<Scalars['String']['output']>;
};

export type WorkScheduleType = {
  __typename?: 'WorkScheduleType';
  /** Interval end in 12-hour format (e.g. '9:30 PM'). */
  closeTime: Scalars['String']['output'];
  /** Interval end, seconds since local midnight. */
  closeTimeSeconds: Scalars['Int']['output'];
  /** Day of week number, 0-based (0 = Monday, 6 = Sunday). */
  dayNumber: Scalars['Int']['output'];
  /** Interval start in 12-hour format (e.g. '11:00 AM'). */
  openTime: Scalars['String']['output'];
  /** Interval start, seconds since local midnight. */
  openTimeSeconds: Scalars['Int']['output'];
};
